<div *ngIf="report">
  <div [style]="styles.header.page">
    <div [style]="styles.header.text">
      <b *ngIf="isFacilitator; else coachingHeader">
        HOW TO IMPROVE YOUR USE OF FACILITATOR STYLES AND EXPRESSIONS
      </b>
      <ng-template #coachingHeader>
        <b>HOW TO IMPROVE YOUR USE OF COACHING STYLES AND EXPRESSIONS</b>
      </ng-template>
    </div>
    <div [style]="styles.header.line"></div>
  </div>

  <div [style]="styles.container_padding">

    <!-- Facilitator Version -->
    <ng-container *ngIf="isFacilitator; else coachingCopy">
      <p [style]="styles.paragraph">
        The phrase, "practice makes perfect" is thrown around a lot. But as you may know, you can practice the wrong
        thing over and over, and it won't help you improve.
      </p>

      <p [style]="styles.paragraph">
        However, there are several ways you can practice and maximize your results
      </p>

      <p [style]="styles.paragraph">
        1) Start keeping track of how you use the RESPECT Styles™ in your facilitated sessions. One way to do this is
        to take a moment after the session and reflect on which styles you employed. Did you use one primary style or
        interweave multiple styles? The more you bring these styles into your awareness, the more conscious you'll be
        of using them in the moment when you need them.
      </p>

      <p [style]="styles.paragraph">
        2) Post a list of the RESPECT Styles™ on a computer or wherever you facilitate – maybe written on a piece of
        paper you can see. This will help provide a visual reminder to use the styles.
      </p>

      <p [style]="styles.paragraph">
        3) Create a style challenge for a day or a week where you attempt to use a style of your choosing more often.
      </p>

      <p [style]="styles.paragraph">
        4) If you're interested in mastering the RESPECT Styles™ or being able to debrief and teach the RESPECT Coaching
        Styles™ to others, consider taking the RESPECT Coaching Styles™ certification program or debriefer training
        yourself. This gives you the most in-depth training available and allows you to move fluidly between styles and
        between the direct and indirect expressions of each style. For more information, visit
        <a [style]="styles.highlight" href="http://owlhub.com" target="_blank">http://owlhub.com</a> or email
        <a [style]="styles.highlight" href="mailto:info@owlhub.com">info&#64;owlhub.com</a>.
      </p>
    </ng-container>

    <!-- Coaching Version -->
    <ng-template #coachingCopy>
      <p [style]="styles.paragraph">
        The phrase, "practice makes perfect" is thrown around a lot. But as you may know, you can practice the wrong
        thing over and over, and it won't help you improve.
      </p>

      <p [style]="styles.paragraph">
        However, there are several ways you can practice and maximize your results
      </p>

      <p [style]="styles.paragraph">
        1) Start keeping track of how you use the RESPECT Coaching Styles™ in your coaching interactions. One way to
        do this is to take a moment after the session and reflect on which styles you employed. Did you use one primary
        style or interweave multiple styles? The more you bring these styles into your awareness, the more conscious
        you'll be of using them in the moment when you need them.
      </p>

      <p [style]="styles.paragraph">
        2) Post a list of the RESPECT Coaching Styles™ on a computer monitor or another surface in the location where
        you coach. This will help provide a visual reminder to use the styles.
      </p>

      <p [style]="styles.paragraph">
        3) Create a coaching style challenge for a day or a week where you attempt to use a style of your choosing more
        often.
      </p>

      <p [style]="styles.paragraph">
        4) For those interested in mastering the RESPECT Coaching Styles™ or being able to debrief and teach the RESPECT
        Coaching Styles™ to others, consider taking the RESPECT Coaching Styles™ certification program or debriefer
        training yourself. This gives you the most in-depth training available and allows you to move fluidly between
        styles and between the direct and indirect expressions of each style. For more information, visit
        <a [style]="styles.highlight" href="http://owlhub.com" target="_blank">http://owlhub.com</a> or email
        <a [style]="styles.highlight" href="mailto:info@owlhub.com">info&#64;owlhub.com</a>.
      </p>
    </ng-template>

  </div>
</div>